<template>
  <div>
    <tabs
      :niveau="2"
      :links="tabList"
      :current-tab="tab"
      @changeView="tab = $event"
      mode="emitter"
      :level="2"
      class="has-background-light is-border-bottom"></tabs>
    <table
      class="table is-hoverable is-striped-v is-fullwidth is-first-fixed-xsmall is-marginless-bottom"
      v-if="rdvsToDisplay && rdvsToDisplay.length">
      <thead>
        <tr class="is-size-6">
          <th>Statut</th>
          <th>Date</th>
          <th>Type</th>
          <th>Participant</th>
          <th v-if="displayContact">
            Contact
          </th>
          <th>Adresse</th>
          <th>Invités</th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="is-border-top is-size-6"
          v-for="(rdv, index) in rdvsToDisplay"
          :key="'tr' + index">
          <td class="has-text-centered">
            <span
              v-if="rdv.status !== 'new'"
              :data-tooltip="rdvStatus[rdv.status].label"
              class="dot tooltip is-tooltip-right"
              :class="rdvStatus[rdv.status].color"></span>
          </td>
          <td
            @click="goToDay(rdv.date)"
            class="is-cell-hoverable has-cursor-pointer">
            {{ rdv.date | prettyFullDatetime }}
          </td>
          <td>
            {{ rdv.rdv_type }}
          </td>
          <td class="is-cell-hoverable">
            <router-link :to="{name: 'UserVue', params: {id: rdv.user.pk}}">
              {{ rdv.user.last_name }} {{ rdv.user.first_name }}
            </router-link>
          </td>
          <td
            class="is-cell-hoverable"
            v-if="displayContact">
            <router-link :to="{name: 'ContactVue', params: {id: rdv.contact.pk}}">
              {{ rdv.contact.last_name }} {{ rdv.contact.first_name }}
            </router-link>
          </td>
          <td>
            <span v-if="rdv.address && rdv.address.city && rdv.address.line1 && rdv.address.line1">{{ rdv.address.line1 }}, {{ rdv.address.zip_code }} {{ rdv.address.city }}</span>
            <span v-else>--</span>
          </td>
          <td :class="{'is-cell-hoverable' : rdv.guests.length >= 1}">
            <span
              v-for="(guest, idx) in rdv.guests"
              :key="guest.pk">
              <router-link :to="{name: 'UserVue', params: {id: guest.pk}}">{{ guest.last_name }} {{ guest.first_name }}</router-link>
              <span v-if="idx + 1 < rdv.guests.length"> - </span><br>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="is-padding"
      v-else>
      Aucun rendez-vous à afficher
    </div>
  </div>
</template>

<script>
import DefaultValues from '@/mixins/DefaultValues.js'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'RdvsLightList',
  mixins: [DefaultValues],
  props: {
    rdvs: {
      type: Array,
      require: true
    }
  },
  data () {
    return {
      tab: 'NEXT'
    }
  },
  computed: {
    ...mapState(['currentUser']),
    ...mapGetters(['isAdmin', 'isPromoteur']),
    tabList () {
      return [
        { label: `A venir (${this.nextRdvs.length})`, link: 'NEXT' },
        { label: `Historique (${this.previousRdvs.length})`, link: 'PREVIOUS' },
        { label: `Annulé et reporté (${this.otherRdvs.length})`, link: 'OTHER' }
      ]
    },
    displayContact () {
      return !this.$route.path.split('/').includes('contacts')
    },
    rdvsToDisplay () {
      let panel = {
        NEXT: this.nextRdvs,
        PREVIOUS: this.previousRdvs,
        OTHER: this.otherRdvs
      }
      return panel[this.tab]
    },
    nextRdvs () {
      let excludeStatus = ['deferred', 'canceled']
      let nextRdvs = this.rdvs.filter(x => {
        return !excludeStatus.includes(x.status) && moment().isBefore(moment(x.date))
      })
      return nextRdvs
    },
    previousRdvs () {
      let excludeStatus = ['deferred', 'canceled']
      let previousRdvs = this.rdvs.filter(x => {
        return !excludeStatus.includes(x.status) && moment().isAfter(moment(x.date))
      })
      return previousRdvs
    },
    otherRdvs () {
      let includesSatus = ['deferred', 'canceled']
      let otherRdvs = this.rdvs.filter(x => {
        return includesSatus.includes(x.status)
      })
      return otherRdvs
    }
  },
  methods: {
    goToDay (date) {
      let day = moment(date).format('DD')
      let month = moment(date).format('MM')
      let year = moment(date).format('YYYY')
      this.$router.push({ name: 'CalendarDay', params: { year, month, day, panel: 'rdvs' } })
    }
  }
}
</script>
